const selectGraphType = (graphType) => {
  switch (graphType) {
    case 'piechart':
      return window.ReportGraphs.Piechart
    default:
      return window.ReportGraphs.Linechart
  }
}

export default selectGraphType
